import * as React from 'react';
import { GridCustomCellProps } from "@progress/kendo-react-grid";

const CustomerNameCell = (props: GridCustomCellProps) => {
  if (!props.field) return null;

  return (
    <td {...props.tdProps} style={{ color: props.dataItem.OnCreditHold ? 'red' : undefined }}>
      {props.dataItem.CustomerName}
    </td>
  );
}

export default React.memo(CustomerNameCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
